import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { IMerchant } from "@/interfaces/merchant.interfaces";
import { getFileUrl, getFormattedDateTime } from "@/utils";

export const MerchantDetailsCard: React.FC<{ merchant: IMerchant }> = ({ merchant }) => {
  const getStatusBadgeStyle = (status: string) => {
    return status === "Active" 
      ? "bg-green-100 text-green-800 hover:bg-green-100"
      : "bg-red-100 text-red-800 hover:bg-red-100";
  };
  return (
    <Card className="border border-gray-200">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <Avatar className="h-32 w-32 rounded-lg border">
            <AvatarImage src={merchant?.merchantImageUri} alt={merchant?.merchantName} className="object-cover" />
            <AvatarFallback className="rounded-lg text-lg font-semibold">
              {(merchant?.merchantName || '')?.charAt(0)}
            </AvatarFallback>
          </Avatar>
          
          <div className="flex-1">
            <div className="flex items-start justify-between">
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-1">{merchant?.merchantName}</h2>
                {merchant?.businessDescription && (
                  <p className="text-sm text-gray-500 mb-2">{merchant.businessDescription}</p>
                )}
                <p className="text-sm text-gray-600 mb-0">{merchant?.businessLocation}</p>
                <p className="text-sm text-gray-600 mb-3">{merchant?.city}, {merchant?.country}</p>
              </div>
              <div className="flex flex-col items-end gap-2">
                <Badge
                  variant="outline"
                  className={getStatusBadgeStyle("Active")}
                >
                  Active
                </Badge>
                <Badge variant="outline" className="bg-blue-100 text-blue-800 hover:bg-blue-100">
                  {merchant?.businessType}
                </Badge>
              </div>
            </div>

            {merchant?.createdDateInMillis && (
              <div className="mt-3 pt-3 border-t border-gray-100">
                <p className="text-sm text-gray-500">
                  Created on {getFormattedDateTime(merchant.createdDateInMillis)} by {merchant?.createdBy || "Administrator"}
                </p>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
